import React from "react";
import { GENDER_FORM_SELECT_OPTIONS } from "../shared/utils/genderOptions";

export default function GenderSelect({
  id,
  value,
  onChange,
  disabled = false,
  required = false,
  className = "input select",
  onBlur,
  autoFocus,
  "aria-label": ariaLabel,
}) {
  return (
    <select
      id={id}
      value={value ?? ""}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      required={required}
      className={className}
      autoFocus={autoFocus}
      aria-label={ariaLabel || "Gender"}
    >
      {GENDER_FORM_SELECT_OPTIONS.map((opt) => (
        <option key={opt.value || "placeholder"} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
